import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kv-message-nav',
  templateUrl: './message-nav.component.html',
  styleUrls: ['./message-nav.component.scss']
})
export class MessageNavComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
